import { useModuleBEM } from "@b2bportal/core-themes";
import type { DueAtPropertyAmount } from "@b2bportal/lodging-api";
import { useCheckoutStateSelector } from "@checkout/index";
import { useI18nContext } from "@hopper-b2b/i18n";
import { getRbcLodgingPriceBreakdown } from "./getRbcLodgingPriceBreakdown";
import styles from "./PayAtProperty.module.scss";

export const PayAtProperty = ({
  fiatFormatOptions,
}: {
  fiatFormatOptions?: Intl.NumberFormatOptions;
}) => {
  const [block, cn] = useModuleBEM(styles, "PayAtProperty");
  const { t, formatFiatCurrency } = useI18nContext();

  const breakdown = useCheckoutStateSelector(getRbcLodgingPriceBreakdown);
  const dueAtProperty = breakdown?.taxesAndFeesDueAtProperty;

  // FTC-defined pay-at-property buckets, in display order.
  const lines: { key: string; label: string; amount?: DueAtPropertyAmount }[] =
    [
      {
        key: "resortFees",
        label: "lodgingPriceBreakdown.resortFees",
        amount: dueAtProperty?.resortFees,
      },
      {
        key: "mandatoryFees",
        label: "lodgingPriceBreakdown.mandatoryFee",
        amount: dueAtProperty?.mandatoryFees,
      },
      {
        key: "mandatoryTaxes",
        label: "lodgingPriceBreakdown.mandatoryTax",
        amount: dueAtProperty?.mandatoryTaxes,
      },
    ].filter((line) => (line.amount?.value.fiat.value ?? 0) > 0);

  if (lines.length === 0) {
    return null;
  }

  return (
    <div className={block}>
      <div className={cn("pay-at-property")}>
        <p className={cn("title")}>
          {t("lodgingPriceBreakdown.taxesAndFeesAtCheckIn")}
        </p>
        {lines.map(({ key, label, amount }) => (
          <div key={key} className={cn("item", [key])}>
            <p className={cn("item-label")}>{t(label)}</p>
            <p className={cn("item-value")}>
              {formatFiatCurrency(amount?.value.fiat, fiatFormatOptions)}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
};
